<template>
  <v-container fluid fill-height class="loginOverlay">
    <v-layout flex align-center justify-center>
      <v-flex xs12 md6 lg4 elevation-6>
        <v-toolbar class="pa-4 tool-bar-app darken-1" style="height: 100%;">
          <v-layout justify-center align-center fill-height style="height: 100%;">
            <img class="login--logo" src="@/assets/imagens/logo_mono_cp.png" alt="Logo siged" @mouseover="masterValidation">
          </v-layout>
        </v-toolbar>
        <v-form name="loginform" @submit.prevent="submit" v-model="valid" ref="form">
          <v-card>
            <v-card-text class="pt-4">
              <div>
                <div class="nome-tela"  aria-live="assertive" >{{nomeTela}}</div>
                  <p style="opacity:100; color:red; font-size:10px; margin:0px; padding:0px;" id="nome-tela-auxiliar" aria-live="assertive"  ></p>
             </div>
                            
                <v-text-field
                  label="Informe seu endereço de e-mail"
                  v-model="email"
                  name="login"
                  prepend-icon="email"
                  autofocus
                  :error-messages="$v.$dirty && $v.email.$invalid ?['Não é um email válido!'] : ''"
                ></v-text-field>
                <v-text-field
                  label="Informe sua senha"
                  v-model="password"
                  min="8"
                  name="senha"
                  prepend-icon="lock"
                  :append-icon="passvisible ? 'visibility' : 'visibility_off'"
                  @click:append="() => (passvisible = !passvisible)"
                  :type="passvisible ? 'text' : 'password'"
                  :rules="passwordRules"
                  :error-messages="$v.$dirty && !$v.password.minLength ? ['O tamanho mínimo é de 8 caracteres'] : ''"
                  counter
                ></v-text-field>
                <v-alert
                  :value="errorMessage"
                  type="error"
                  transition="scale-transition"
                >
                  {{errorMessage}}
                </v-alert>
              </div>
            </v-card-text>
          </v-card>
          <v-card>
            <v-card-text>
              <v-layout align-center justify-end>
                <v-btn
                  type="submit"
                  :loading="loading"
                  :class=" { 'accent white--text rounded-sm font-weight-regular' : valid, disabled: !valid }"
                  :disabled="!valid"
                >
                Acessar
                </v-btn>
                <v-btn to="/cadastro" class="blue white--text rounded-sm font-weight-regular" style="margin-left: 15px;">Cadastrar</v-btn>
                <router-link to="redefinir-senha" style="margin-left: 15px;">Esqueci minha senha</router-link>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { required, minLength, email } from 'vuelidate/lib/validators';
import store from '@/store/index';

export default {
  data() {
    return {
      ix:0,
      loading: false,
      valid: false,
      passvisible: false,
      password: "",
      passwordRules: [v => !!v || "O campo senha é obrigatório"],
      email: "",
      emailRules: [
        v => !!v || "O campo e-mail é obrigatório",
        v =>
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail com formato inválido"
      ],
      errorMessage: false,
      nomeTela: ""
    };
  },
  validations: {
    password: { required, minLength: minLength(8) },
    email: { required, email },
  },
  beforeRouteEnter (to, from, next) {
    if (store.getters.isLoggedIn) { return next('/'); }
    next();
  },

created() {
   document.addEventListener('keydown', this.onKeyDown);
  },
  
  methods: {
    ...mapActions(['login','inserirAvatar',]),
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) { return; }

      this.loading = true;
      this.errorMessage = false;
      try {
        let ret = await this.login({login: this.email, password: this.password});
        this.inserirAvatar();
        this.$router.push({
          path: '/escolher-perfil'
        });
      }
      catch(err){
        let msg = err.errorMessage ? err.errorMessage[0] : null;
        this.usuarioInvalido(msg);
        this.loading = false;
      }
    },
    usuarioInvalido(msg){
      this.errorMessage = msg;
      setTimeout(() => this.invalido = null, 2500);
    },
    clear() {
      this.$refs.form.reset();
    },
    masterValidation(){
     this.ix = this.ix+1;
      if(this.ix==100){
        alert('Quê?')
        this.ix = 0;
      }
    },

        onKeyDown(event)  {
      if (event.altKey && event.key === 't') {
        let elementoParaLeitura = document.getElementById('nome-tela-auxiliar');

        if (elementoParaLeitura.textContent !== '') {
          elementoParaLeitura.textContent = 'Você está na tela de loguin';
          setTimeout(() => {onKeyDown(event)},2500);
          } else {
            let conteudoLeitura =  "Você está na tela: " + document.getElementsByClassName('nome-tela')[0].textContent;
                elementoParaLeitura.textContent = conteudoLeitura;
                setTimeout(() => {elementoParaLeitura.textContent = ''},250)
          };
      };
    }   


  }
};
</script>

<style lang="scss" scoped>
.loginOverlay {
  background-image: url("~@/assets/login-bg.png");
  background-repeat: repeat;
}

.login--logo {
  height: 100%;
}
</style>
